export const LEGAL_PATHS = {
  ANGLER_TERMS: '/legal/angler-terms',
  SWIMBOOKER_PLUS_TERMS: '/legal/swimbooker-plus-terms',
  VENUE_PARTNER_TERMS: '/legal/venue-partner-terms',
  PRIVACY_POLICY: '/legal/privacy-policy',
  COOKIE_POLICY: '/legal/cookie-policy',
  COMPLAINTS: '/legal/complaints',
};

export const ANGLER_TERMS_CANCELLATIONS_URL = `${LEGAL_PATHS.ANGLER_TERMS}#changes-cancellations-and-refunds`;
